import React from 'react';
import { Grid } from '@mui/material';

import defaultImage from '@shared/assets/slides-noImg/no-hotel1.png';

import HotelFavoritesDialog from './HotelFavoritesDialog';
import useHotelCardLogic from '@HotelSearchHooks/useHotelCardLogic';
import OmitHotelDialog from './OmitHotelDialog';
import DeleteFavoriteHotelDialog from './DeleteFavoriteHotelDialog';
import HotelCardList from '../../SharedHotelCardContent/HotelCardList';

const HotelCard = ({
  hotel,
  tokenMap,
  hotReferenceCities,
  fav_messages,
  getFavConfig,
  onCardMouseEnter,
  onCardMouseLeave,
  sites,
  business_types,
  user,
  isMobile,
  searchInfo,
  onMoveMap,
}) => {
  const {
    isLoading,
    setIsLoading,
    compare,
    isLoadImage,
    setIsLoadImage,
    showModalFavoritos,
    setShowModalFavoritos,
    showModalOmitidos,
    setShowModalOmitidos,
    showModalDeleteFavorite,
    setShowModalDeleteFavorite,
    isShowAlert,
    setIsShowAlert,
    alertOptions,
    setAlertOptions,
    integration,
    provider,
    handleImageError,
    handleChangePage,
    fetchNewOmitted,
    fetchDeletedFavorite,
    usdUserTooltip,
    setUsdUserTooltip,
    favMessage,
    handleFavMessage,
    handleMouseLeave,
    hasIdFav,
    handleMouseEnter,
    setHasIdFav,
  } = useHotelCardLogic({ hotel, tokenMap, hotReferenceCities, user });

  const isAdmin = user?.role?.name === 'admin';

  return (
    <Grid
      onMouseEnter={onCardMouseEnter}
      onMouseLeave={onCardMouseLeave}
      id="GRIDCARDAIR"
      sx={{ display: 'flex', justifyContent: 'center' }}
    >
      <HotelCardList
        onMoveMap={onMoveMap}
        hotel={hotel}
        hasIdFav={hasIdFav}
        isLoadImage={isLoadImage}
        setIsLoadImage={setIsLoadImage}
        getFavConfig={getFavConfig}
        handleImageError={handleImageError}
        defaultImage={defaultImage}
        handleChangePage={handleChangePage}
        provider={provider}
        integration={integration}
        handleMouseEnter={handleMouseEnter}
        setUsdUserTooltip={setUsdUserTooltip}
        handleMouseLeave={handleMouseLeave}
        business_types={business_types}
        compare={compare}
        usdUserTooltip={usdUserTooltip}
        isMobile={isMobile}
        searchInfo={searchInfo}
        user={user}
        onClickAddFavorite={() => setShowModalFavoritos(true)}
        onClickOmit={() => setShowModalOmitidos(true)}
        onClickDeleteFavorite={() => setShowModalDeleteFavorite(true)}
        isAdmin={isAdmin}
      />

      {showModalFavoritos && (
        <HotelFavoritesDialog
          showModalFavoritos={showModalFavoritos}
          setShowModalFavoritos={setShowModalFavoritos}
          isLoading={isLoading}
          isShowAlert={isShowAlert}
          alertOptions={alertOptions}
          favMessage={favMessage}
          handleFavMessage={handleFavMessage}
          fav_messages={fav_messages}
          setIsShowAlert={setIsShowAlert}
          setIsLoading={setIsLoading}
          hotReferenceCities={hotReferenceCities}
          user={user}
          hotel={hotel}
          setAlertOptions={setAlertOptions}
          sites={sites}
          isAdmin={isAdmin}
          setHasIdFav={setHasIdFav}
        />
      )}

      {showModalOmitidos && (
        <OmitHotelDialog
          open={showModalOmitidos}
          onClose={() => setShowModalOmitidos(false)}
          hotelName={hotel.name}
          isLoading={isLoading}
          isShowAlert={isShowAlert}
          alertOptions={alertOptions}
          onOmit={fetchNewOmitted}
          onAlertClose={() => {
            setShowModalOmitidos(false);
            setIsShowAlert(false);
          }}
        />
      )}

      {showModalDeleteFavorite && (
        <DeleteFavoriteHotelDialog
          open={showModalDeleteFavorite}
          onClose={() => setShowModalDeleteFavorite(false)}
          hotelName={hotel.name}
          isLoading={isLoading}
          isShowAlert={isShowAlert}
          alertOptions={alertOptions}
          onDelete={fetchDeletedFavorite}
          onAlertClose={() => {
            setShowModalDeleteFavorite(false);
            setIsShowAlert(false);
          }}
        />
      )}
    </Grid>
  );
};

export default React.memo(HotelCard);
